import { DENOMS, FLOAT, money, cashCents } from "../../lib/closing";

const NumInput = ({ value, onChange, testid, step = "1", placeholder = "0" }) => (
  <input type="number" min="0" step={step} inputMode={step === "1" ? "numeric" : "decimal"} value={value} placeholder={placeholder}
    onChange={(e) => onChange(e.target.value)}
    className="w-28 h-12 px-3 text-right text-xl font-mono bg-neutral-950 border border-neutral-700 rounded focus:border-yellow-400 outline-none"
    data-testid={testid} />
);

export const RegisterCountForm = ({ reg, data, onChange }) => {
  const cash = cashCents(data.counts) / 100;
  const setCount = (k, v) => onChange({ ...data, counts: { ...data.counts, [k]: v } });
  return (
    <div data-testid={`closing-register-${reg}`}>
      <div className="bg-neutral-900 border border-neutral-800 rounded-lg p-5">
        <div className="text-[10px] font-bold uppercase tracking-[0.24em] text-neutral-400 mb-3">Count coins and bills — register {reg}</div>
        <div className="divide-y divide-neutral-800">
          {DENOMS.map((d) => (
            <div key={d.key} className="flex items-center justify-between py-2 gap-3">
              <span className="flex-1 min-w-0 font-medium whitespace-nowrap">{d.label}</span>
              <NumInput value={data.counts[d.key] ?? ""} onChange={(v) => setCount(d.key, v)} testid={`closing-${reg}-count-${d.key}`} />
              <span className="w-24 sm:w-28 text-right font-mono text-neutral-400 whitespace-nowrap">{money((parseInt(data.counts[d.key], 10) || 0) * d.value)}</span>
            </div>
          ))}
        </div>
        <div className="mt-4 pt-4 border-t border-neutral-700 space-y-1 font-mono">
          <div className="flex justify-between text-lg font-bold"><span>Cash in drawer</span><span data-testid={`closing-${reg}-cash-total`}>{money(cash)}</span></div>
          <div className="flex justify-between text-neutral-400"><span>Keep in drawer (float)</span><span>− {money(FLOAT)}</span></div>
          <div className={`flex justify-between text-lg font-bold ${cash < FLOAT ? "text-red-400" : "text-green-400"}`}>
            <span>Cash to deposit</span><span data-testid={`closing-${reg}-cash-deposit`}>{money(cash - FLOAT)}</span>
          </div>
          {cash < FLOAT && <div className="text-xs text-red-400">Drawer is short of the $200 float.</div>}
        </div>
      </div>
      <div className="bg-neutral-900 border border-neutral-800 rounded-lg p-5 mt-4 space-y-3">
        <label className="flex items-center justify-between gap-3">
          <span className="font-medium">Checks total (register {reg})</span>
          <NumInput step="0.01" placeholder="0.00" value={data.checks} onChange={(v) => onChange({ ...data, checks: v })} testid={`closing-${reg}-checks`} />
        </label>
        <label className="flex items-center justify-between gap-3">
          <span className="font-medium">Total sale from POS {reg}</span>
          <NumInput step="0.01" placeholder="0.00" value={data.sale} onChange={(v) => onChange({ ...data, sale: v })} testid={`closing-${reg}-sale`} />
        </label>
      </div>
    </div>
  );
};
